import { useRef, useState } from "react";
import { CarWithDealer } from "../data/models";
import ButtonExpandContent from "./ButtonExpandContent";
import ExpandContent from "./ExpandContent";
import Carousel from "./Carousel";
import ArrowRight from "../../src/assets/svg/carouselRight.svg";
import ArrowLeft from "../../src/assets/svg/carouselLeft.svg";
import clsx from "clsx";

export interface CarouselsContainerProps {
  similar_vehicles: CarWithDealer[];
  dealer_vehicles: CarWithDealer[];
}

export default function CarouselsContainer(props: CarouselsContainerProps) {
  const { similar_vehicles, dealer_vehicles } = props;
  const scrollContainerRef1 = useRef<HTMLDivElement>(null);
  const scrollContainerRef2 = useRef<HTMLDivElement>(null);
  const [open1, setOpen1] = useState<Boolean>(true);
  const [open2, setOpen2] = useState<Boolean>(false);

  const scrollLeft1 = () => {
    if (scrollContainerRef1.current) {
      scrollContainerRef1.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };
  const scrollRight1 = () => {
    if (scrollContainerRef1.current) {
      scrollContainerRef1.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  const scrollLeft2 = () => {
    if (scrollContainerRef2.current) {
      scrollContainerRef2.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };
  const scrollRight2 = () => {
    if (scrollContainerRef2.current) {
      scrollContainerRef2.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  return (
    <>
      {similar_vehicles?.length > 0 && (
        <div className={clsx("flex flex-col", open1 && "gap-6")}>
          <ButtonExpandContent
            onClick={() => setOpen1((prev) => !prev)}
            onClickWhole={false}
            open={open1}
            title="Otkrijte slična vozila"
            textSize="text-xl"
            className="uppercase"
            fontWeight="font-bold"
          >
            {open1 && (
              <div className="flex flex-shrink-0 gap-8">
                <button onClick={scrollLeft1}>
                  <img src={ArrowLeft} alt="Arrow left"></img>
                </button>
                <button onClick={scrollRight1}>
                  <img src={ArrowRight} alt="Arrow right"></img>
                </button>
              </div>
            )}
          </ButtonExpandContent>
          <ExpandContent open={open1}>
            <Carousel
              data={similar_vehicles}
              scrollContainerRef={scrollContainerRef1}
            ></Carousel>
          </ExpandContent>
        </div>
      )}
      <hr className="w-full border-t-1 border-extra-light" />

      {dealer_vehicles?.length > 0 && (
        <div className={clsx("flex flex-col", open2 && "gap-6")}>
          <ButtonExpandContent
            onClick={() => setOpen2((prev) => !prev)}
            onClickWhole={false}
            open={open2}
            title={
              dealer_vehicles[0].dealer !== null
                ? `Vozila distributera ${dealer_vehicles[0].dealer.name.toUpperCase()}`
                : "Vozila distributera"
            }
            textSize="text-xl"
            className="uppercase"
            fontWeight="font-bold"
          >
            {open2 && (
              <div className="flex flex-shrink-0 gap-8">
                <button onClick={scrollLeft2}>
                  <img src={ArrowLeft} alt="Arrow left"></img>
                </button>
                <button onClick={scrollRight2}>
                  <img src={ArrowRight} alt="Arrow right"></img>
                </button>
              </div>
            )}
          </ButtonExpandContent>
          <ExpandContent open={open2}>
            <Carousel
              data={dealer_vehicles}
              scrollContainerRef={scrollContainerRef2}
            ></Carousel>
          </ExpandContent>
        </div>
      )}
    </>
  );
}
